(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["RPECK-tabs"] && !Shopify.designMode) return;
  try {
    
  window.update_page = function(e) {

    // RPECK 07/05/2025 - Get the page info
    // This is triggered by the "onchange" event, which means that it will occur after the event
    let page    = e.dataset.page;
    let content = document.getElementById('page-content');

    // RPECK 07/05/2025 - Check to see if the page value is present
    // If it is, proceed to get the data from the endpoint and populate the page with it
    if (page) {

      // RPECK 07/05/2025 - Fetch the page
      // This requires sending the data to Shopify but is needed so we can use sections
      fetch(`/pages/${page}`).then(function(response) {
        return response.text();
      }).then(function(response){

        // RPECK 07/05/2025 - Get the HTML from the returned text values and use it to populate everything
        const parser = new DOMParser();
        const event  = new Event('tab_change');

        // Parse the text
        const doc = parser.parseFromString(response, "text/html");

        // You can now even select part of that html as you would in the regular DOM
        const main = doc.querySelector('main').innerHTML;

        // RPECK 07/05/2025 - If the content exists, update it
        if(content) {

          // RPECK 22/05/2025 - Set the URL with the tab
          let url  = new URL(window.location);
          url.hash = page;

          // RPECK 22/05/2025 - PushState to update the URL
          history.pushState({}, '', url);

          // RPECK 07/05/2025 - Update the content innerHTML
          content.innerHTML = main;

          // RPECK 07/05/2025 - Trigger Event
          document.dispatchEvent(event);

        }
        
      });
      
    }
    
  }

  // RPECK 07/05/2025 - Start by showing the page
  document.addEventListener('DOMContentLoaded', function(){

    // RPECK 07/05/2025 - Get the first tab
    let url = new URL(window.location);
    let tab = document.querySelector('ul.tab-blocks li:first-of-type > input');

    // RPECK 22/05/2025 - Check to see if the tab has a hash value
    // If it does, use that, otherwise select the first tab
    if(url.hash) tab = document.querySelector('ul.tab-blocks input[data-page="' + url.hash.replace('#', '') + '"]');

    // RPECK 07/05/2025 - Run the tab if it's present
    if(tab) {//window.update_page(tab);

      let event = new Event('change');
      tab.click();
      
    }
    
  });

  } catch(e) { console.error(e); }
})();
})();
